<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="500"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-if="value" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>

      <v-btn v-else color="primary" dark small v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="mt-2"><v-form ref="form" v-model="isValid">
        <v-alert
          type="error"
          v-if="Boolean(error)"
          outlined
        >{{ error }}</v-alert>

        <files-table
          :smIndex="12"
          label="Фото бонуса *"
          :singleFile="true"
          v-model="obj.image"
          :key="componentId"
        ></files-table>
        <v-text-field
          label="Заголовок *"
          v-model="obj.name"
          filled
          :rules="[v => !!v || 'Введите заголовок.']"
        ></v-text-field>
        <v-textarea
          label="Описание"
          v-model="obj.description"
          filled
        ></v-textarea>
       
      </v-form></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save()"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';
import { getTempId } from '../../../models/common';

export default {
  name: 'site-page-bonus-card',
  props: {
    value: Object,
  },
  data() {
    //alert(this.value);
    return {
      activeMode: false,
      isValid: false,
      error: '',
      obj: Boolean(this.value) ? _.cloneDeep(this.value) : this.getDefaultObj(),
      title: this.value ? 'Карточка бонуса' : 'Создание бонуса',
      componentId: getTempId()
    }
  },
  methods: {
    getDefaultObj() {
      return {
        image: [],
        name: '',
        description: ''
      };
    },
    save() {
      this.$refs.form.validate();
      this.error = '';
      if (this.isValid) {
        if (this.obj.image.length == 0) {
          this.error = 'Выберите фотографию';
          return;
        }
        this.$emit('input', this.obj);
        this.$nextTick(() => this.closeForm());
      } 
    },
    closeForm() {
      this.activeMode = false;
      this.obj = this.value ? _.cloneDeep(this.value) : this.getDefaultObj();
      this.$refs.form.resetValidation();
      this.componentId = getTempId();
      this.error = '';
    }
  },
}
</script>